<div class="d-flex flex-column gap-4">
  <div class="d-flex flex-column" [style.gap.rem]="(investmentInstructionsHaveChanged$ | async) ? 0.5 : 1">
    <div class="title-md" i18n>Investment Instructions</div>
    <div *ngIf="investmentInstructionsHaveChanged$ | async" class="paragraph-lg" i18n>
      {{ descriptionText$ | async }}
    </div>
    <div *ngIf="!(investmentInstructionsHaveChanged$ | async)" class="no-changes" i18n>No Changes</div>
  </div>
  <div *ngIf="investmentInstructionsHaveChanged$ | async" class="d-flex flex-column gap-4">
    <app-previous-instructions-submission-visualization
      [submission]="submission$ | async"
      [forcedColumns]="forcedColumns$ | async"
      [borderColor]="'#C63221'"
      [backgroundColor]="'#FCEBEA'" />
    <app-future-instructions-visualization
      [instructions]="newInvestmentInstructions$ | async"
      [forcedColumns]="forcedColumns$ | async"
      [borderColor]="'#13856B'"
      [backgroundColor]="'#E8F3F1'" />
  </div>
</div>
